import { useContext } from 'react';
import { useMealPlanSurfacingLogic } from 'src/pages/consumer/meal-plans/hooks/useMealPlanSurfacingLogic';
import { MealPlanSubscriptionContext } from 'src/pages/consumer/meal-plans/MealPlanSubscriptionsContext';
import { ExistingSubscriberBanner } from './components/ExistingSubscriberBanner';
import { NewSubscriberBanner } from './components/NewSubscriberBanner';

export const ExploreMealPlanBanner = () => {
  const { shouldShowMealPlanBanner } = useMealPlanSurfacingLogic();
  const { userHasActiveMealPlan, mealPlanDataLoaded } = useContext(MealPlanSubscriptionContext);

  if (!shouldShowMealPlanBanner || !mealPlanDataLoaded) {
    return null;
  }

  return userHasActiveMealPlan ? <ExistingSubscriberBanner /> : <NewSubscriberBanner />;
};
